<template>
  <div class="base-empty-state">
    <a-empty :image="image" class="base-empty-state__empty">
      <span slot="description" class="base-empty-state__description">
        <h3 class="base-empty-state__title">{{ title }}</h3>
        <p v-if="subtitle" class="base-empty-state__subtitle">{{ subtitle }}</p>
      </span>

      <div class="base-empty-state__actions">
        <a-button
          v-if="showSecondaryButton"
          class="base-empty-state__action base-empty-state__action--secondary"
          :aria-label="secondaryButtonAriaLabel || secondaryButtonText"
          :loading="secondaryButtonLoading"
          :disabled="secondaryButtonDisabled"
          @click="$emit('secondary-action')"
        >
          <a-icon v-if="secondaryButtonIcon" :type="secondaryButtonIcon" />
          {{ secondaryButtonText }}
        </a-button>

        <a-button
          v-if="showButton"
          type="primary"
          class="base-empty-state__action"
          :aria-label="buttonAriaLabel || buttonText"
          @click="$emit('action')"
        >
          <a-icon v-if="buttonIcon" :type="buttonIcon" />
          {{ buttonText }}
        </a-button>
      </div>
    </a-empty>
  </div>
</template>

<script>
import { Empty } from "ant-design-vue";

export default {
  name: "BaseEmptyState",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    buttonText: { type: String, required: true },
    buttonIcon: { type: String, default: "plus" },
    buttonAriaLabel: { type: String, default: "" },
    showButton: { type: Boolean, default: true },
    secondaryButtonText: { type: String, default: "" },
    secondaryButtonIcon: { type: String, default: "" },
    secondaryButtonAriaLabel: { type: String, default: "" },
    showSecondaryButton: { type: Boolean, default: false },
    secondaryButtonLoading: { type: Boolean, default: false },
    secondaryButtonDisabled: { type: Boolean, default: false },
    image: {
      type: [String, Function],
      default: () => Empty.PRESENTED_IMAGE_SIMPLE,
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.base-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  height: 100%;
  padding: 48px;

  &__empty {
    text-align: center;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: @color-text-dark;
    margin-bottom: 8px;
    margin-top: 16px;
  }

  &__subtitle {
    font-size: 14px;
    color: @color-text-medium;
    max-width: 320px;
    margin: 0 auto 24px auto;
    line-height: 1.5;
  }

  &__actions {
    display: inline-flex;
    align-items: center;
    gap: 12px;
  }

  &__action {
    background-color: @color-primary;
    border-color: @color-primary;
    border-radius: 4px;
    height: 40px;
    padding: 0 24px;
    font-weight: 500;

    &:hover,
    &:focus {
      background-color: @color-primary-hover;
      border-color: @color-primary-hover;
    }

    &--secondary {
      color: rgba(0, 0, 0, 0.88);
      border-color: #d9d9d9;
      background-color: #ffffff;
      box-shadow: none;

      &:hover,
      &:focus {
        color: rgba(0, 0, 0, 0.88);
        border-color: #bfbfbf;
        background-color: #ffffff;
      }
    }
  }
}
</style>
